import React from 'react'

import {Text} from '@vio/atlas/Text'
import FormattedMessageWrapper from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  isCheapest?: boolean
  isOnlySplitBookingOfferAvailable?: boolean
  hasCustomStyle?: boolean
}

const MessageText = ({
  isCheapest,
  isOnlySplitBookingOfferAvailable
}: Pick<Props, 'isCheapest' | 'isOnlySplitBookingOfferAvailable'>) => {
  if (isOnlySplitBookingOfferAvailable) {
    return (
      <FormattedMessageWrapper
        id="splitBooking.onlyOfferSubtitle"
        defaultMessage="Your dates are sold out everywhere, but we worked a little magic. We’ve combined these two rooms so you can stay here on your preferred dates."
      />
    )
  }

  if (isCheapest)
    return (
      <FormattedMessageWrapper
        id="splitBooking.mainSubtitle"
        defaultMessage="Split your dates between these two bookings to get the best price."
      />
    )

  return (
    <FormattedMessageWrapper
      id="splitBooking.switchRoomAndSaveSubtitle"
      defaultMessage="Save money by splitting your dates between these two bookings."
    />
  )
}

export const SplitBookingCardSubtitle = ({
  isCheapest = true,
  isOnlySplitBookingOfferAvailable = false,
  hasCustomStyle
}: Props) => {
  return (
    <Text
      variant={hasCustomStyle ? 'bodyS' : 'bodyM'}
      colorPath={
        hasCustomStyle ? 'content.neutral.secondary' : 'content.neutral.primary'
      }
    >
      <MessageText
        isCheapest={isCheapest}
        isOnlySplitBookingOfferAvailable={isOnlySplitBookingOfferAvailable}
      />
    </Text>
  )
}
